export enum WorkType {
  Movie,
  TvShow,
  Episode
}
